
import { lazy } from 'react';
import { RouteConfig } from './types';

// Lazy load components
const SettingsPage = lazy(() => import('../pages/settings/SettingsPage'));
const RBACSettings = lazy(() => import('../pages/settings/RBACSettings'));
const SystemHealth = lazy(() => import('../pages/SystemHealth'));
const Help = lazy(() => import('../pages/Help'));
const AccessControlDashboard = lazy(() => import('../components/access-control/AccessControlDashboard'));
const PermissionMatrix = lazy(() => import('../components/access-control/PermissionMatrix'));
const UserManagement = lazy(() => import('../pages/access-control/UserManagement'));
const RoleManagement = lazy(() => import('../pages/access-control/RoleManagement'));
const ResourceManagement = lazy(() => import('../pages/access-control/ResourceManagement'));

export const systemRoutes: RouteConfig[] = [
  // System health (admin only)
  { 
    path: "/app/system-health", 
    element: SystemHealth, 
    requiresLayout: true,
    requiredRoles: ['admin'],
    requiredPermissions: ['system.read']
  },
  
  // Help page (available to all users)
  { 
    path: "/app/help", 
    element: Help, 
    requiresLayout: true
    // No permissions required - all users should have access to help
  },
  
  // System settings (admin only)
  { 
    path: "/app/settings", 
    element: SettingsPage, 
    requiresLayout: true,
    requiredPermissions: ['settings.read']
  },
  { 
    path: "/app/settings/rbac", 
    element: RBACSettings, 
    requiresLayout: true,
    requiredRoles: ['admin'],
    requiredPermissions: ['rbac.read']
  },
  
  // Access control routes (admin/manager only)
  { 
    path: "/app/access-control", 
    element: AccessControlDashboard, 
    requiresLayout: true,
    requiredRoles: ['admin', 'manager'],
    requiredPermissions: ['access_control.read']
  },
  { 
    path: "/app/access-control/dashboard", 
    element: AccessControlDashboard, 
    requiresLayout: true,
    requiredRoles: ['admin', 'manager'],
    requiredPermissions: ['access_control.read']
  },
  { 
    path: "/app/access-control/permissions", 
    element: PermissionMatrix, 
    requiresLayout: true,
    requiredRoles: ['admin'],
    requiredPermissions: ['permissions.manage']
  },
  { 
    path: "/app/access-control/users", 
    element: UserManagement, 
    requiresLayout: true,
    requiredRoles: ['admin', 'manager'],
    requiredPermissions: ['users.manage']
  },
  { 
    path: "/app/access-control/roles", 
    element: RoleManagement, 
    requiresLayout: true,
    requiredRoles: ['admin'],
    requiredPermissions: ['roles.manage']
  },
  { 
    path: "/app/access-control/resources", 
    element: ResourceManagement, 
    requiresLayout: true,
    requiredRoles: ['admin'],
    requiredPermissions: ['resources.manage']
  }
];
